$(document).ready(function() {
    $(document).on('click', '.remove-client-resource-js', function() {
        var $btn = $(this);
        const client_resource_id = $btn.data('client-resource-id');

        $.post('/components/clients/meetings/resource_list/remove_client_resource', {
            client_resource_id: client_resource_id
        }).done(function(data) {
            // Remove the resource element from the DOM in real time
            $btn.closest('.resource-item').remove();
        });
    });
});